import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import FilterHeader from './FilterHeader';
import FilterList from './FilterList';
import FilterSwatchGrid from './FilterSwatchGrid';

const FilterGroupContainer = styled.div``;

export class FilterGroup extends Component {
  static propTypes = {
    filterGroupData: PropTypes.object.isRequired,
    filterType: PropTypes.oneOf(['sort', 'filter']).isRequired,
    isMobile: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    const { filterGroupData } = props;
    this.state = {
      isColorFilter: filterGroupData.slug === 'colors',
    };
  }

  render() {
    const { filterGroupData, filterType, isMobile } = this.props;
    const { isColorFilter } = this.state;
    const FilterType = isColorFilter ? FilterSwatchGrid : FilterList;

    return (
      <FilterGroupContainer>
        <FilterHeader>{filterGroupData.name}</FilterHeader>
        <FilterType
          filterGroupData={filterGroupData}
          filterType={filterType}
          isMobile={isMobile}
        />
      </FilterGroupContainer>
    );
  }
}

export default FilterGroup;
